import { render, staticRenderFns } from "./FittingSwingList.vue?vue&type=template&id=2589ba7f"
import script from "./FittingSwingList.vue?vue&type=script&lang=js"
export * from "./FittingSwingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports